import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import integrationService from '../../services/api/integrationService';

export default function EvaTestBusinessAccessEditor({ client, onSaved }) {
  const { t } = useTranslation();
  const [review, setReview] = useState(null);
  const [enabled, setEnabled] = useState(false);
  const [reason, setReason] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const state = client.evaTestBusinessAccess;
  if (!state || (!state.eligible && !state.hasScope)) return null;
  const show = async () => {
    // Freeze the reviewed identity/revision. A background list refresh must
    // not silently turn an obsolete review into permission for a newer state.
    setBusy(true); setError('');
    try {
      const clients = await integrationService.listApiClients();
      const fresh = clients.find(item => String(item.id) === String(client.id));
      if (!fresh || fresh.revokedAt) { setError(t('evaTestBusinessAccess.stale')); return; }
      setReview(fresh); setEnabled(fresh.evaTestBusinessAccess.hasScope); setReason('');
    } catch (err) { setError(err.message); }
    finally { setBusy(false); }
  };
  const save = async () => {
    setBusy(true); setError('');
    try {
      await integrationService.updateEvaTestBusinessAccess(client.id, { enabled, reason: reason.trim(),
        expectedPrincipalId: review.principalId, expectedPermissionRevision: review.permissionRevision,
        expectedUpdatedAt: review.updatedAt });
      setReview(null); await onSaved();
    } catch (err) {
      if (err.status === 409) { setReview(null); setError(t('evaTestBusinessAccess.stale')); }
      else setError(err.message);
    } finally { setBusy(false); }
  };
  return <div>
    {!review ? <button type="button" disabled={busy} onClick={show}>{t('evaTestBusinessAccess.title')}</button> : <fieldset style={{ minWidth: 240 }}>
      <legend>{t('evaTestBusinessAccess.title')} — {review.name}</legend>
      <p>{t('evaTestBusinessAccess.description')}</p>
      <p>{t('evaTestBusinessAccess.authority', { client: review.id, principal: review.principalId, revision: review.permissionRevision })}</p>
      <p>{t(`evaTestBusinessAccess.states.${review.evaTestBusinessAccess.reason}`)}</p>
      <label style={{ display: 'block' }}>
        <input type="checkbox" checked={enabled} disabled={busy || (!enabled && !review.evaTestBusinessAccess.canEnable)}
          onChange={event => setEnabled(event.target.checked)} /> {t('evaTestBusinessAccess.allow')}
      </label>
      <p>{t('evaTestBusinessAccess.withdrawal')}</p>
      <label style={{ display: 'block' }}>{t('evaTestBusinessAccess.reason')}
        <textarea value={reason} maxLength={500} disabled={busy} onChange={event => setReason(event.target.value)} />
      </label>
      <button type="button" disabled={busy || reason.trim().length < 10 || !review.permissionRevision
        || enabled === review.evaTestBusinessAccess.hasScope || (enabled && !review.evaTestBusinessAccess.canEnable)} onClick={save}>{t('evaTestBusinessAccess.save')}</button>{' '}
      <button type="button" disabled={busy} onClick={() => setReview(null)}>{t('common.cancel')}</button>
    </fieldset>}
    {error && <p role="alert">{error}</p>}
  </div>;
}
